import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/index.css";

// Global error handler
window.addEventListener("error", (e) => {
  console.error("Global error:", e);
});

// Prevent zoom on double-tap (iOS-like behavior)
let lastTouchEnd = 0;
document.addEventListener("touchend", (e) => {
  const now = Date.now();
  if (now - lastTouchEnd <= 300) {
    e.preventDefault();
  }
  lastTouchEnd = now;
}, { passive: false });

// Prevent pull-to-refresh on mobile
window.addEventListener("touchmove", (e) => {
  if (e.target === document.body) {
    e.preventDefault();
  }
}, { passive: false });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);